import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Capital, {
  IneligibleTermLoan,
  IneligibleInvestment,
  IneligibleFastLoan,
  StatusInvestment,
  StatusFastLoan,
  FastLoan,
  Investment,
  TermLoan,
  FastLoanTenor,
} from 'pages/Capital';
import createCustomRoute from 'hocs/createCustomRoute';

const CapitalRoutes = createCustomRoute('CapitalRoutes', props => (
  <Route {...props}>
    <IndexRoute component={Capital} />
    <Route path="term-loan" component={TermLoan} />
    <Route path="term-loan/conditions" component={IneligibleTermLoan} />
    <Route path="fast-loan" component={FastLoan} />
    <Route path="fast-loan/status" component={StatusFastLoan} />
    <Route path="fast-loan/conditions" component={IneligibleFastLoan} />
    <Route path="fast-loan/tenor" component={FastLoanTenor} />
    <Route path="investment" component={Investment} />
    <Route path="investment/status" component={StatusInvestment} />
    <Route path="investment/conditions" component={IneligibleInvestment} />
  </Route>
));

export default CapitalRoutes;
